class ClickDimensionsForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.successAlert = self.elem.querySelector('[data-click-dimensions-form-success-alert]');
    }

    init() {
        let self = this;
        
        // Listen for when the form has been added to the DOM by the ClickDimensions script
        const observer = new MutationObserver(function(mutations_list) {
            mutations_list.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(added_node) {
                    if(added_node.classList && added_node.classList.contains('clickdform')) {
                        self.replaceCalendarIcon();
                        self.styleChecksAndRadios();
                        self.formSubmit();
                        observer.disconnect();
                    }
                });
            });
        });
        
        observer.observe(self.elem, {
            subtree: true,
            childList: true
        });
    }

    replaceCalendarIcon() {
        let self = this;

        let images = self.elem.querySelectorAll('.ui-datepicker-trigger');

        [...images].map(image => {
            image.setAttribute('src', '/assets/images/calendar.svg');
        });
    }

    styleChecksAndRadios() {
        let self = this;

        let radioInputs = self.elem.querySelectorAll('input[type="radio"], input[type="checkbox"]');

        [...radioInputs].map(input => {
            input.classList.add('form-check-input');
            input.parentElement.classList.add('form-check');
        });
    }
    
    formSubmit() {
        let self = this;
        
        // Get the form
        let form = document.getElementById('clickdimensionsForm');
        let formData = new FormData(form);

        form.addEventListener('submit', evt => {
            evt.preventDefault();

            // Submit the form
            fetch('/', {
                method: 'post',
                body: formData,
            })
            .then(response => console.log(response))
            .catch(error => console.log(error));

            // Show success alert
            self.successAlert.classList.remove('d-none');
        });
    }
}

export default ClickDimensionsForm;
